function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Collapse, { Panel } from 'rc-collapse';
import Swipeout from 'rc-swipeout';
import { Input, TextArea } from '../../../Input';
import MotoEntryPanel from './MotoEntryPanel';
import MotoDetailsPanel from './MotoDetailsPanel';
import AwardSelector from './AwardSelector';
import PhotosPanel from '../PhotosPanel';
import './RiderPanel.css';

var RiderPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(RiderPanel, _React$Component);

  function RiderPanel(props) {
    var _this;

    _classCallCheck(this, RiderPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RiderPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "selectMoto", function (moto) {
      var selectedMoto = _this.state.selectedMoto;

      if (selectedMoto === moto) {
        _this.setState({
          selectedMoto: undefined
        });
      } else {
        _this.setState({
          selectedMoto: moto
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTotalRidersChanged", function (event) {
      var updateLogBookEntry = _this.props.updateLogBookEntry;
      var entry = _this.props.entry;
      entry.totalRiders = event.target.value;
      updateLogBookEntry();
      return event.target.value;
    });

    _defineProperty(_assertThisInitialized(_this), "deleteEntry", function () {
      var _this$props = _this.props,
          logBookEntry = _this$props.logBookEntry,
          entry = _this$props.entry,
          updateLogBookEntry = _this$props.updateLogBookEntry,
          deleteLogBookEntry = _this$props.deleteLogBookEntry;
      var idx = logBookEntry.riderEntries.indexOf(entry);

      if (idx >= 0) {
        if (logBookEntry.riderEntries.length === 1) {
          deleteLogBookEntry();
        } else {
          logBookEntry.riderEntries.splice(idx, 1);
          updateLogBookEntry();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeNotes", function (event) {
      var _this$props2 = _this.props,
          updateLogBookEntry = _this$props2.updateLogBookEntry,
          logBookEntry = _this$props2.logBookEntry;
      logBookEntry.notes = event.target.value;
      updateLogBookEntry();
      return logBookEntry.notes;
    });

    _this.state = {
      selectedMoto: undefined
    };
    return _this;
  }

  _createClass(RiderPanel, [{
    key: "render",
    value: function render() {
      var selectMoto = this.selectMoto,
          onTotalRidersChanged = this.onTotalRidersChanged,
          deleteEntry = this.deleteEntry,
          onChangeNotes = this.onChangeNotes;
      var _this$props3 = this.props,
          logBookEntry = _this$props3.logBookEntry,
          entry = _this$props3.entry,
          mapMotoName = _this$props3.mapMotoName,
          width = _this$props3.width,
          updateLogBookEntry = _this$props3.updateLogBookEntry,
          isPractice = _this$props3.isPractice,
          setCurrentLogBookEntry = _this$props3.setCurrentLogBookEntry,
          storage = _this$props3.storage;
      var selectedMoto = this.state.selectedMoto;
      return React.createElement("div", {
        className: "rider"
      }, React.createElement(Swipeout, {
        right: [{
          text: 'delete',
          onPress: deleteEntry,
          style: {
            backgroundColor: 'rgba(var(--danger-color), .5)',
            color: 'rgba(var(--foreground-color), 1)'
          }
        }]
      }, React.createElement("div", {
        className: "title"
      }, React.createElement("div", {
        className: "name"
      }, entry.rider.name), !isPractice && React.createElement("div", {
        className: "proficiency"
      }, entry.ageGroup)), React.createElement("div", {
        className: "extras"
      }, !isPractice && React.createElement(Input, {
        className: "compact",
        style: {
          padding: '0px 0px'
        },
        label: "Total Riders",
        locked: false,
        active: false,
        type: "number",
        value: entry.totalRiders,
        onChange: onTotalRidersChanged
      })), React.createElement("div", {
        className: "add-rider",
        onClick: function onClick(e) {
          return setCurrentLogBookEntry(logBookEntry);
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faPlus,
        className: "icon"
      }))), !isPractice && React.createElement(React.Fragment, null, React.createElement(Collapse, {
        accordion: true,
        activeKey: selectedMoto ? '1' : '0',
        className: "moto-details-accordion"
      }, React.createElement(Panel, {
        header: "Motos",
        key: "0"
      }, React.createElement("div", {
        className: "motos"
      }, React.createElement("div", {
        className: "rounds"
      }, entry.motos.map(function (moto) {
        return React.createElement(MotoEntryPanel, {
          logBookEntry: logBookEntry,
          entry: entry,
          moto: moto,
          selectMoto: selectMoto,
          mapMotoName: mapMotoName,
          key: moto.id,
          updateLogBookEntry: updateLogBookEntry
        });
      })))), React.createElement(Panel, {
        header: "Moto Details",
        key: "1"
      }, React.createElement(MotoDetailsPanel, {
        logBookEntry: logBookEntry,
        entry: entry,
        moto: selectedMoto,
        selectMoto: selectMoto,
        mapMotoName: mapMotoName,
        updateLogBookEntry: updateLogBookEntry,
        width: width,
        storage: storage
      }))), React.createElement(AwardSelector, {
        logBookEntry: logBookEntry,
        entry: entry,
        width: width,
        updateLogBookEntry: updateLogBookEntry
      })), React.createElement("div", {
        className: "notes"
      }, React.createElement(TextArea, {
        label: "Rider Notes",
        locked: false,
        active: false,
        type: "text",
        value: logBookEntry.notes,
        onChange: onChangeNotes
      })), React.createElement(PhotosPanel, {
        width: width,
        parent: entry,
        updateLogBookEntry: updateLogBookEntry,
        storage: storage
      }));
    }
  }]);

  return RiderPanel;
}(React.Component);

export default RiderPanel;